import { useEffect, useRef, useState } from "react";
import { LoaderCircle, X } from "lucide-react";
import { useNotification } from "../../../../hooks/useNotification";

export default function AddFriendModal({ isOpen, setIsOpen, addFriend, shop }) {
  const [contentPlaceHolder, setContentPlaceHolder] = useState("");
  const [contentAddFriend, setContentAddFriend] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const contentInputRef = useRef();
  const { addNotification } = useNotification();

  const handleSaveClick = async () => {
    try {
      setIsLoading(true);
      await addFriend(contentAddFriend);
      setIsLoading(false);
      setIsOpen(false);
    } catch (error) {
      setIsLoading(false);
      addNotification(error.message, -1);
    }
  };

  const handleCloseClick = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    if (isOpen) {
      setContentPlaceHolder(
        `Xin chào, mình là ${shop?.name}. Kết bạn với mình nhé!`
      );
      setContentAddFriend("");
      contentInputRef.current?.focus();
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white text-black rounded-lg w-full max-w-md p-6">
        <div className="flex justify-between items-center mb-4 pb-2 border-b">
          <h2 className="text-xl font-semibold">Nội dung kết bạn</h2>
          <button
            onClick={handleCloseClick}
            className="text-gray-500 hover:text-gray-700 transition-colors duration-200"
          >
            <X size={20} />
          </button>
        </div>
        <div className="space-y-2">
          <div className="flex items-center gap-4">
            <textarea
              type="text"
              placeholder={contentPlaceHolder}
              value={contentAddFriend}
              onChange={(e) =>
                setContentAddFriend(e.target.value.slice(0, 150))
              }
              rows={5}
              className="flex-1 px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none"
              ref={contentInputRef}
              spellCheck={false}
              res
            />
          </div>
          <div className="flex justify-end text-sm text-gray-500">
            {contentAddFriend.length}/150
          </div>

          {/* Save Button */}
          <div className="flex justify-end">
            <button
              onClick={handleSaveClick}
              className={`px-6 py-2 ${
                isLoading ? "bg-blue-400" : "bg-blue-600"
              } text-white rounded-md ${
                isLoading ? "hover:bg-blue-400" : "hover:bg-blue-700"
              } transition-colors flex items-center`}
              disabled={isLoading}
            >
              {isLoading && (
                <LoaderCircle
                  className="animate-spin text-white mr-2"
                  width={20}
                  height={20}
                />
              )}
              Kết bạn
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
